import moment from "moment";
import { useState } from "react";
import { Link } from "react-router-dom";
import brokenImage from "../../images/brokenImage.jpg"; // import the fallback image

function SecondOfferBox({ promotion, imageURL }) {
    // const imageURL = "https://devp.mycomsys.com:8807/files/";
    const [isImgLoading, setIsImgLoading] = useState(true);
    return (
        <Link
            to={`/offers/single/${promotion.PROMO_ID}/${promotion.PROMO_CODE}`}
            className="text-decoration-none"
        >
            <div className="w-95 mx-auto bg-wafaa-white-2 rounded-4 shadow-wafaa-bg p-3 mb-3">
                {/* Banner Image */}
                <div className="position-relative overflow-hidden rounded-4">
                    <img
                        src={imageURL + promotion.PROMO_IMAGE}
                        alt="Promotion"
                        className="w-100 object-fit-cover"
                        style={{
                            height: "220px",
                            filter: isImgLoading ? "blur(10px)" : "none",
                            transition: "filter 0.3s ease-out",
                        }}
                        onError={(e) => {
                            e.target.src = brokenImage;
                            setIsImgLoading(false);
                        }}
                        onLoad={() => setIsImgLoading(false)}
                    />

                    {/* Overlay Content */}
                    <div
                        className="position-absolute bottom-0 start-0 w-100 p-3"
                        style={{
                            background:
                                "linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0.1))",
                        }}
                    >
                        <h2
                            className="text-white fw-bold mb-0"
                            style={{
                                fontSize: "1.5rem",
                                lineHeight: "1.2",
                                textShadow: "0 0 10px black",
                            }}
                        >
                            {promotion.PROMO_DESC}
                        </h2>
                    </div>
                </div>

                {/* Description */}
                <p
                    className="mt-3 mb-4 text-wafaa-grey-5"
                    style={{
                        fontSize: "15px",
                        lineHeight: "1.7",
                    }}
                >
                    {promotion.DESC}
                </p>

                {/* Dates */}
                <div className="row">
                    <div className="col-6">
                        <p
                            className="text-uppercase text-wafaa-grey-5 mb-1"
                            style={{
                                fontSize: "12px",
                                letterSpacing: "0.5px",
                            }}
                        >
                            Starts
                        </p>

                        <h6 className="fw-bold text-wafaa-black-3 mb-0">
                            {moment(promotion.VALID_FROM).format("DD MMM YYYY")}
                        </h6>
                    </div>

                    <div className="col-6 text-end">
                        <p
                            className="text-uppercase text-wafaa-grey-5 mb-1"
                            style={{
                                fontSize: "12px",
                                letterSpacing: "0.5px",
                            }}
                        >
                            Ends
                        </p>

                        <h6 className="fw-bold text-wafaa-black-3 mb-0">
                            {moment(promotion.VALID_TO).format("DD MMM YYYY")}
                        </h6>
                    </div>
                </div>
            </div>
        </Link>
    );
}

export default SecondOfferBox;
